<template>
  <div class="dialog-container">
    <div class="marker-main" v-show="visible" @click.stop="closeDialog">
      <div class="main-section">
        <div class="main-header">
          <div class="header-content">
            <div class="header-title">{{ detail.name }}</div>
            <div class="header-subtitle">
              <span class="sub-item">{{ detail.area }}</span>
              <span class="sub-item">/</span>
              <span class="sub-item">{{ detail.edu }}</span>
              <span class="sub-item">/</span>
              <span class="sub-item">{{ detail.station }}</span>
            </div>
          </div>
          <img class="close-btn" src="/static/images/about/join/close.png" alt="关闭按钮" @click.stop="closeDialog">
        </div>
        <div class="main-content">
          <div class="content-body">
            <div class="content-item" v-if="detail.duty">
              <div class="item-title">{{$t('join_detail.text1')}}</div>
              <div class="item-desc" v-html="resetStrToHuanHang(detail.duty)"></div>
              <!-- <div class="item-desc">1. 负责无人机相关业务应用层功能开发;</div>
              <div class="item-desc">2. 负责多旋翼无人机、垂直起降无人机的导航及控制算法的开发与优化;</div>
              <div class="item-desc">3. 负责无人机与其他模块通信协议的制定及文档编写;</div>
              <div class="item-desc">4. 负责无人机相关载荷及传感器的驱动/应用的开发与调试。</div> -->
            </div>
            <div class="content-item" v-if="detail.demand">
              <div class="item-title">{{$t('join_detail.text2')}}</div>
              <div class="item-desc" v-html="resetStrToHuanHang(detail.demand)"></div>
              <!-- <div class="item-desc">1. 具备扎实的C/C++语言能力，优秀的软件架构能力和良好的编码风格；</div>
              <div class="item-desc">2. 了解传感器误差模型、掌握GPS/INS组合导航算法；</div>
              <div class="item-desc">3. 掌握飞行动力学、控制相关知识，掌握PID原理及调参手段；</div>
              <div class="item-desc">4. 精通STM32平台开发，熟悉Freertos/Threadx/RT-Thead等嵌入式实时操作系统的使用方法。</div> -->
            </div>
          </div>
          <div class="content-footer">
            <div class="footer-main">
              <div class="footer-left"></div>
              <div class="footer-right">
                <div class="right-item">
                  <img class="item-img" src="/static/images/about/join/email.png" alt="email">
                  <div class="item-text">
                    <p class="text-label">{{$t('join_detail.text3')}}</p>
                    <p class="text-value">{{$t('join_detail.text4')}}</p>
                  </div>
                </div>
                <div class="right-item">
                  <!-- <img class="item-img" src="/static/images/about/join/tel.png" alt="telphone"> -->
                  <div class="item-text" style="width: 100px;">
                    <p class="text-label"></p>
                    <p class="text-value"></p>
                  </div>
                </div>
                <div class="right-item" @click.stop="(function () { return false; })()">
                  <a class="btn-main" href="https://wj.qq.com/s2/8798603/b2ec/" target="_blank">
                    <img class="main-img" src="/static/images/about/join/upload.png" alt="投递简历">
                    <span class="main-text">{{$t('join_detail.text5')}}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JobDetail',
  props: {
    id: {
      type: String,
      default: ""
    }
  },
  data () {
    return {
      visible: true,
      detail: {},
      
    };
  },
  created () {
    this.jobContent=this.$i18n.t('join_detail.jobContent');
    
    this.detail = this.jobContent.filter(item => item.id === this.id)[0];
    console.log(this.detail);
  },
  methods: {
    resetStrToHuanHang (str) {
      return str.replace(/\n/g, "<br/>");
    },
    closeDialog () {
      this.visible = false;
      this.$emit("closeDialog");
    }
  }
};
</script>

<style lang="stylus" scoped>
.dialog-container {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  z-index: 2000;

  .marker-main {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;

    .main-section {
      width: 860px;

      .main-header {
        height: 144px;
        background: url('/static/images/about/join/bg.png') no-repeat center center;
        background-size: contain;
        position: relative;

        .header-content {
          padding: 30px 40px;

          .header-title {
            font-size: 30px;
            color: #FFFFFF;
            line-height: 42px;
          }

          .header-subtitle {
            padding-top: 20px;
            font-size: 16px;
            color: #FFFFFF;
            line-height: 22px;

            .sub-item {
              padding-right: 10px;
            }
          }
        }

        .close-btn {
          width: 20px;
          height: 20px;
          position: absolute;
          right: 20px;
          top: 20px;
          cursor: pointer;
        }
      }

      .main-content {
        min-width: unset;
        background: #fff;

        .content-body {
          max-height: 470px;
          overflow-y: auto;
          padding: 0 40px;

          // max-height: 300px;
          // overflow-y: auto;
          .content-item {
            padding-top: 20px;
            padding-bottom: 50px;
            color: #111111;

            // border-bottom: 1px solid #EBEBEB;
            .item-title {
              font-size: 18px;
              line-height: 36px;
            }

            .item-desc {
              font-size: 14px;
              line-height: 28px;
            }
          }
        }

        .content-footer {
          padding: 0 40px;

          .footer-main {
            width: 100%;
            display: flex;
            padding: 20px 0;
            border-top: 1px solid #EBEBEB;

            .footer-left {
              // flex: 1;
              display: none;
            }

            .footer-right {
              // width: 420px;
              width: 100%;
              display: flex;

              .right-item {
                display: inline-block;
                padding-right: 20px;
                vertical-align: top;

                &:last-child {
                  padding-right: 0;
                  margin-left: 92px;
                }

                .item-img {
                  display: inline-block;
                  width: 45px;
                  height: 45px;
                  vertical-align: top;
                }

                .item-text {
                  padding-left: 10px;
                  display: inline-block;
                  vertical-align: top;

                  .text-label {
                    font-size: 14px;
                    color: #777777;
                    line-height: 20px;
                  }

                  .text-value {
                    font-size: 16px;
                    font-weight: 500;
                    color: #111111;
                    line-height: 22px;
                  }
                }

                .btn-main {
                  display: block;
                  width: 280px;
                  height: 45px;
                  border: 1px solid #007BE7;
                  border-radius: 25px;
                  text-align: center;
                  line-height: 45px;
                  box-sizing: border-box;

                  .main-img {
                    width: 24px;
                    height: 24px;
                    margin-top: 10px;
                    margin-right: 5px;
                    vertical-align: top;
                  }

                  .main-text {
                    font-size: 16px;
                    color: #007BE7;
                    vertical-align: top;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// 移动端
@media all and (min-width: 320px) and (max-width: 768px) {
  .dialog-container {
    .marker-main {
      .main-section {
        width: 100%;

        .main-header {
          height: 72px;
          background-size: cover;

          .header-content {
            padding: 10px 20px;

            .header-title {
              font-size: 18px;
              line-height: 24px;
            }

            .header-subtitle {
              padding-top: 10px;
              font-size: 14px;
              line-height: 18px;

              .sub-item {
                padding-right: 5px;
              }
            }
          }

          .close-btn {
            width: 16px;
            height: 16px;
            position: absolute;
            right: 16px;
            top: 16px;
            cursor: pointer;
          }
        }

        .main-content {
          .content-body {
            max-height: 200px;
            overflow-y: auto;
            padding: 0 20px;

            .content-item {
              padding-top: 10px;
              padding-bottom: 20px;

              .item-title {
                font-size: 16px;
                line-height: 26px;
              }

              .item-desc {
                font-size: 14px;
                line-height: 22px;
              }
            }
          }

          .content-footer {
            padding: 0 20px;

            .footer-main {
              width: 100%;
              display: block;
              padding: 20px 0;
              border-top: 1px solid #EBEBEB;

              .footer-left {
                display: none;
              }

              .footer-right {
                width: 100%;
                display: block;

                .right-item {
                  padding-right: 0;
                  display: inline-block;
                  box-sizing: border-box;

                  &:last-child {
                    display: block;
                    padding-right: 0;
                    margin-left: 0;
                    margin-top: 10px;
                  }

                  .item-img {
                    display: inline-block;
                    width: 36px;
                    height: 36px;
                    vertical-align: top;
                  }

                  .item-text {
                    padding-left: 10px;
                    display: inline-block;
                    vertical-align: top;

                    .text-label {
                      font-size: 12px;
                      color: #777777;
                      line-height: 18px;
                    }

                    .text-value {
                      font-size: 14px;
                      font-weight: 500;
                      color: #111111;
                      line-height: 20px;
                    }
                  }

                  .btn-main {
                    width: 100%;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/join/detail.vue